export default "__VITE_ASSET__CY0Fe5Nq__"